import { IPositionType } from 'src/generated-types/position-type'

export const CONFIGURE_TYPE_ORDER: IPositionType[] = [
  IPositionType.FrameLines,
  IPositionType.Bridle,
  IPositionType.MooringLine,
  IPositionType.Corner,
  IPositionType.InnerMooringLine,
  IPositionType.BargeCorner,
  IPositionType.ElectricityLine,
  IPositionType.Polygon,
]

export const MIN_ZOOM = 0.5
export const MAX_ZOOM = 5
export const ZOOM_STEP = 1.25

export const FADED_OPACITY = '0.3'

export const isUngroupedName = (name?: string | null) => {
  if (!name?.trim()) return true
  return name.trim().toLowerCase() === 'unassigned'
}

export const compareDrawingNumbers = (a: { drawingNumber: string }, b: { drawingNumber: string }) => {
  return a.drawingNumber.localeCompare(b.drawingNumber, undefined, { numeric: true })
}

export const typeLabelKey = (type: IPositionType) => {
  switch (type) {
    case IPositionType.FrameLines:
      return 'frameLines'
    case IPositionType.Bridle:
      return 'bridles'
    case IPositionType.MooringLine:
      return 'mooringLines'
    case IPositionType.Corner:
      return 'corners'
    default:
      return IPositionType[type]
  }
}

export const tint = (hex: string, amount: number) => {
  const colorValue = parseInt(hex.slice(1), 16)
  const red = colorValue >> 16
  const green = (colorValue >> 8) & 255
  const blue = colorValue & 255
  const mixWithWhite = (channel: number) => Math.round(channel * amount + 255 * (1 - amount))
  return `rgb(${mixWithWhite(red)}, ${mixWithWhite(green)}, ${mixWithWhite(blue)})`
}

export const clampZoom = (zoom: number) => {
  const clampedZoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, zoom))
  return Math.round(clampedZoom * 100) / 100
}
